import { render, staticRenderFns } from "./DetailTankPage.vue?vue&type=template&id=5def371c&"
import script from "./DetailTankPage.vue?vue&type=script&lang=js&"
export * from "./DetailTankPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports